function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from '@domain-group/fe-co-select';
import { Modal, RowButton } from '@domain-group/fe-co-allhomes-design-system';
import { MarketArrowDownIcon, TickIcon } from '@domain-group/fe-co-icon';
import { SORT_OPTIONS } from '../utils/sort-options';
import * as styles from './sort-dropdown.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SortDropdown = props => {
  var _useState = useState(props.value),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mobileMenuOpen = _useState4[0],
    setMobileMenuOpen = _useState4[1];
  return ___EmotionJSX("div", {
    css: styles.container
  }, props.media.mobile ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX("button", {
    css: styles.dropDownToggle,
    onClick: () => {
      setMobileMenuOpen(true);
    },
    type: "button"
  }, ___EmotionJSX("div", {
    css: styles.dropDownToggleLabel
  }, SORT_OPTIONS[value] && SORT_OPTIONS[value].label), ___EmotionJSX(MarketArrowDownIcon, null)), ___EmotionJSX(Modal, {
    animated: false,
    minimal: false,
    css: styles.modalDialog,
    onClose: () => {
      setMobileMenuOpen(false);
    },
    show: mobileMenuOpen,
    title: "Sort by ...",
    mobileStyle: "auto",
    showGradient: false,
    enableScroll: false
  }, ___EmotionJSX("div", {
    css: styles.modalDialogContent
  }, Object.keys(SORT_OPTIONS).map(sortOptionName => ___EmotionJSX(RowButton, {
    key: sortOptionName,
    leftIcon: null,
    title: SORT_OPTIONS[sortOptionName].label,
    rightIcon: value === sortOptionName && ___EmotionJSX(TickIcon, {
      css: styles.modalDialogTick,
      size: "custom"
    }),
    onClick: () => {
      setValue(sortOptionName);
      setMobileMenuOpen(false);
      props.onChange(sortOptionName);
    },
    css: styles.dropDownItem,
    rightIconSize: "medium"
  }))))) : ___EmotionJSX(React.Fragment, null, (props.media.tablet || props.media.desktop) && ___EmotionJSX("div", {
    css: styles.dropDownLabel
  }, "Sort by ..."), ___EmotionJSX("div", {
    css: styles.dropDownContainer
  }, ___EmotionJSX(Select, {
    defaultValue: value,
    css: styles.dropDown,
    labelHidden: true,
    onChange: evt => {
      setValue(evt.value);
      props.onChange(evt.value);
    },
    options: Object.keys(SORT_OPTIONS).map(sortOptionName => ({
      value: sortOptionName,
      label: SORT_OPTIONS[sortOptionName].label
    }))
  }))));
};
SortDropdown.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOf(['SOLD', 'SOLD_TOTAL', 'RENTED', 'RENTED_TOTAL']),
  media: PropTypes.shape({
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
    desktop: PropTypes.bool
  })
};
SortDropdown.defaultProps = {
  media: {},
  value: 'SOLD',
  onChange: () => {}
};
export default SortDropdown;